module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading/heading_7-8ece6d74b8d51eb2ce0f8bdddc5a5cbd.png";